import { CaretLeft } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';
import { useSkillCommand } from 'src/hooks';
import { QUICK_SKILL_COMMANDS, SVG_SIZE_M } from 'src/constants';
import { SkillSettingsControl } from './components/SkillSettingsControl';
import { SkillModelSelector } from './components/SkillModelSelector';
import styles from './SkillCommandSettings.module.scss';
import { useMemo } from 'react';

export const SkillCommandSettings = () => {
  const { activeSkillCommand, toggleActiveSkillCommand } = useSkillCommand();

  const handleBackClick = () => {
    toggleActiveSkillCommand(null);
  };

  const currentSkillLabel = useMemo(
    () =>
      QUICK_SKILL_COMMANDS.find((item) => item.skill === activeSkillCommand)
        ?.title,
    [activeSkillCommand],
  );

  return (
    <div className={styles.root}>
      <Button
        className={styles.backButton}
        color="transparent"
        onClick={handleBackClick}
      >
        <CaretLeft size={SVG_SIZE_M} />
        <span className={styles.skillName}>{currentSkillLabel}</span>
      </Button>

      <div className={styles.commandSettings}>
        <SkillModelSelector />
        <SkillSettingsControl />
      </div>
    </div>
  );
};
